import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import { Button, styled } from "@mui/material"
import React from "react"

interface ScheduleMeetingDialogGoBackButtonProps {
  ariaLabel: string
  onClick: () => void
}

const ScheduleMeetingDialogGoBackButton = (props: ScheduleMeetingDialogGoBackButtonProps) => {
  const { onClick, ariaLabel } = props
  return (
    <_Button
      aria-label={ariaLabel}
      onClick={onClick}
      variant="text"
      color="primary"
      startIcon={<ArrowBackIcon />}>
      Go Back
    </_Button>
  )
}

export default ScheduleMeetingDialogGoBackButton

const _Button = styled(Button)({
  fontWeight: 700,

  "&.MuiButton-root": {
    textTransform: "capitalize",
  },
})
